import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
@Pipe({
  name: 'expiryDays'
})
export class ExpiryDaysPipe implements PipeTransform {

  transform(expiry_date: any) {
    // const current_date: any = moment().format('MM-DD-YYYY');
    // const diff: any = moment(current_date).diff(expiry_date, 'days');
    // const isExpired: boolean = moment().isAfter(moment(expiry_date))

    const today = moment().startOf('day'); 
    const expiry = moment(expiry_date, 'MM-DD-YYYY').startOf('day'); 

    const diff = today.diff(expiry, 'days');
    const isExpired = today.isAfter(expiry);
    const isToday = today.isSame(expiry);
    switch (true) {
      case isToday:
        return 'Expiring Today'
        break;
      case isExpired:
        return `Expired ${diff} ${diff == 1 ? 'day' : 'days'} ago`
        break;
      default:
        return `${expiry.format('DD-MMM-YYYY')}`
        break;
    }
  }

}
